class Activity {
    _id;
    title;
    description;
    talker;
    date;
    status;

    static fromJSON(json) {
        let activity = new Activity();
        activity._id = json.id;
        activity.title = json.title;
        activity.description = json.description;
        activity.talker = json.talker;
        activity.date = json.date_formatted;
        activity.status = json.status;
        return activity;
    }
}

export default Activity;